export const ALLOWED_FILE_EXT = "png,jpeg,jpg";
export const COMPLETED = "COMPLETED";
export const FAILED = "FAILED";
export const DEFAULT_LIMIT_COUNT = 20;
export const COMPANY_SEARCH_COUNT = 20;
export const FILE_LIST_ITEMS = [
  { id: "li-1", title: "History of Business / Executive Summary" },
  { id: "li-2", title: "Organization Chart" },
  {
    id: "li-3",
    title:
      "Most Recent 2 Years Financial Statements (Audited, Reviewed, Compiled or Business Tax Returns with all Schedules)",
  },
  {
    id: "li-4",
    title:
      "Interim Business Financial Statements (Income statement and balance sheet dated no more than 90 days old)",
  },
  { id: "li-5", title: "Business Debt Schedule" },
  { id: "li-6", title: "Business Capital Structure" },
  {
    id: "li-7",
    title:
      "Current Accounts Receivable/Accounts Payable with Aging Reports and/or Borrowing Base Certificate",
  },
  { id: "li-8", title: "Business Income Projections" },
  {
    id: "li-9",
    title:
      "Copies of the Business Most Recent Three (3) Months Bank Statements. If more than one account, include copies for all accounts.",
  },
  { id: "li-10:", title: "Entity(ies) organization documentation" },
];
export const SUPPORTING_DOCUMENT_DISCLAIMER =
  " Disclaimer: Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Sed blandit libero volutpat sed cras ornare arcu dui. Netus et malesuada fames ac turpis egestas integer eget aliquet. In massa tempor nec feugiat nisl.";

export const ALL_COUNTRIES = "All Countries";
export const ALL_INDUSTRY_TYPE = "All Industry Type";
export const COUNTRIES: string[] = [
  "United States",
  "Afghanistan",
  "Australia",
  "Austria",
  "Brazil",
  "Canada",
  "CHINA",
  "Denmark",
  "Egypt",
  "France",
  "GERMANY",
  "NETHERLANDS",
  "ENGLAND",
  "USA",
  "HONG KONG",
  "India",
  "IRELAND",
  "SWITZERLAND",
];

export const INDUSTRIES: string[] = [
  "Industrials",
  "Healthcare",
  "Digital, Tech & Comms",
  "Financial Services",
  "Petroleum & Coal Products",
  "Computers & Other Electronic Products",
  "Motor Vehicles",
  "Motor Vehicles- 2",
  "Electrical Equipment & Appliances",
  "Petroleum & Coal Products- 2",
  "Aerospace & Defense",
  "Petroleum & Coal Products- 3",
  "Computers & Other Electronic Products- 2",
  "Computers & Other Electronic Products- 3",
  "Technology",
];
export const ROLE_LIST: string[] = [
  "Accountant",
  "Account Manager",
  "Assistant",
  "Assistant Director",
  "Assistant Treasurer",
  "Assistant Vice President",
  "Associate",
  "Board",
  "CAO",
  "Capital Markets Executive",
  "Cash Manager",
  "CDO",
  "CEO",
  "CFO",
  "Chairman",
  "Chief Legal Officer & Secretary",
  "Chief Risk Officer",
  "Chief Sustainability Officer",
  "CIO",
  "Client Service",
  "CMO",
  "Commissioner",
  "Compliance Officer",
  "Controller",
  "COO",
  "CSO",
  "CTO",
  "Dealer/Trader",
  "Director",
  "Ex-CEO",
  "Ex-CFO",
  "Ex-Chairman",
  "Executive Director",
  "Ex-Treasurer",
  "Finance Manager",
  "Financial Advisor",
  "Financial Controller",
  "Founder",
  "Fund Manager",
  "General Manager",
  "Investment Director",
  "Investor Relations",
  "Legal Advisor",
  "Managing Director",
  "Managing Partner",
  "Other (Non-Executive Title)",
  "Owner",
  "Partner",
  "President",
  "Product Manager",
  "Promoter",
  "Regional Head",
  "Risk Manager",
  "Senior Financial Manager",
  "Senior Vice President",
  "Shareholder",
  "Treasurer",
  "Treasury Operations",
  "Vice Chairman",
  "Vice President",
];
export const REVENUE_RANGE = ["$5 - $1 m", "$1 m - $2 m", "$2 m - $3 m", "$3 m - $4 m"];
export const VALID_EMAIL = "Where possible please use your company email address to avoid delays.";
export const INVALID_EMAIL = "Please enter a valid email address.";
export const INVALID_EMAIL_DOMAIN =
  "Please note that we prefer a valid corporate email address (@company.com), as this is required for onboarding. If you provide a non-corporate address, this may result in delays or us not being able to address your request.";
export const EMAIL_PATTERN = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
export const BUSINESS_NEED_DESCRIPTION = "Please enter 80–1000 characters to let us know more about your objectives.";
export const BUSINESS_NEED_PLACEHOLDER = "Describe your banking needs in details";
